let _id = 0;
const _storage = new Map();

export default {
  registerData(buffer) {
    const uri = `blob:${_id++}`;
    _storage.set(uri, buffer);

    return uri;
  },

  getData(uri) {
    return _storage.get(uri);
  },
};
